import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/version/page',
  ADD: '/dh-datamaint/version/add',
  DELETE: '/dh-datamaint/version/delete',
  DETAIL: '/dh-datamaint/version/getById',
  UPDATE: '/dh-datamaint/version/update',
  MERGE: '/dh-datamaint/version/merge',
  END: '/dh-datamaint/version/end',
  USER_LIST: '/dh-datamaint/user/listAllOrdinary',
  VERSION_END_LIST: '/dh-datamaint/version/listEnd',
  GET_DEFAULT_NAME: '/dh-datamaint/version/generateVersionName',

  SUBJECT_LIST: '/dh-datamaint/subject/listOnlyCanManage',
  CWSUBJECT_LIST: '/dh-datamaint/cwSubject/listOnlyCanManage',
  EXPSUBJECT_LIST: '/dh-datamaint/expSubject/listOnlyCanManage',
  QUESTIONSUBJECT_LIST: '/dh-datamaint/questionSubject/listOnlyCanManage',
};

class VersionModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.get(URL.PAGE, { params: payload.data });

      res.data.records.forEach((item: any) => {
        if (!item.userList) {
          item.userList = [];
        }

        let userName = '';
        item.userList.forEach((item2: any) => {
          userName += item2.fullName + '(' + item2.loginName + ')' + '/';
        });
        userName = userName.substring(0, userName.length - 1);
        item.userName = userName || '-';
      })

      return res;
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async Merge(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.MERGE, payload.data);
    },

    async End(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.END, payload.data);
    },

    async getUserList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.USER_LIST, { params: payload.data });
    },

    async getVersionEndList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.VERSION_END_LIST, { params: payload.data });
    },

    async getSubjectList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SUBJECT_LIST, { params: payload.data });
    },

    async getDefaultName(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.GET_DEFAULT_NAME, { params: payload.data });
    },

    async getCwSubjectList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.CWSUBJECT_LIST, { params: payload.data });
    },

    async getExpSubjectList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.EXPSUBJECT_LIST, { params: payload.data });
    },

    async getQuestionSubjectList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.QUESTIONSUBJECT_LIST, { params: payload.data });
    }
  };
}

export const versionModule = new VersionModule();
